import type { RawAPIError, RawDetailedAPIError } from 'common/types';

const isDetailedAPIError = (error: RawAPIError): error is RawDetailedAPIError =>
  Boolean(error.response?.data?.detail);

export default isDetailedAPIError;
